import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const factors = async (data: FactorsReqT) => {
  const { pageParam, name, status, archive } = data;

  const qs = `?archived=${archive ? 1 : 0}&page=${pageParam ?? 1}&name=${
    name ?? ""
  }&status=${status ?? ""}`;

  return axios.get(Routes.FACTORS + qs);
};

export const useFactors = (params: FactorsReqT) => {
  const { name, status, archive } = params;
  return useInfiniteQuery({
    queryKey: [Keys.FACTORS_QRY, name, status, archive],
    queryFn: ({ pageParam = 1 }) => factors({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
